 
import { MenuProps } from 'antd'
import { useCallback, useMemo } from 'react'
import { RouteObject,useNavigate, useRoutes } from 'react-router'

import allRoutes from '@/routes'
import { CustomRouteObject } from '@/types/type'
import { useAllAuth } from '@joyu/auth/dist/esm/context/auth-context-provider'
import { filterRoutersByPermission } from '@joyu/auth/dist/esm/utils'
import { RouteConfig } from 'react-router-config'

export default function useGetAuthRoutes(routes?: CustomRouteObject[]) {
  const navigate = useNavigate()
  const allAuth = useAllAuth()

  // 这里直接过滤掉没有权限的path
  const goToPage = useCallback(
    (menu: CustomRouteObject) => {
      // const path = menu.path.toLocaleString();
      navigate(menu.path as any)
    },
    [navigate]
  )

  const menuList = useMemo<MenuProps['items']>(() => {
    const formatMenus = (routers: CustomRouteObject[]): MenuProps['items'] => {
      const arr: MenuProps['items'] = []
      for (let i = 0; i < routers.length; i++) {
        const obj = { ...routers[i] }
        if (obj.hidden) {
          continue
        }
        if (obj.checkAuth) {
          if (Object.hasOwn(allAuth, obj.path as string)) {
            if(obj.children && obj.children.length) {
              const newRouters = formatMenus(obj.children || [])
              if (newRouters && newRouters.length) {
                arr.push({
                  key: obj.path as string,
                  icon: obj.icon,
                  title: obj.name,
                  label: obj.name,
                  children: newRouters,
                })
                continue
              }
            }
            arr.push({
              key: obj.path as string,
              icon: obj.icon,
              title: obj.name,
              label: obj.name,
              onClick: () => {
                goToPage(obj)
              },
            })
            continue
          }
          continue
        }
        if (obj.children && obj.children.length) {
          const newRouters = formatMenus(obj.children)
          if (newRouters && newRouters.length) {
            arr.push({
              key: obj.path as string,
              icon: obj.icon,
              title: obj.name,
              label: obj.name,
              children: newRouters,
            })
            continue
          }
          continue
        }
        arr.push({
          key: obj.path as string,
          icon: obj.icon,
          title: obj.name,
          label: obj.name,
          onClick: () => {
            goToPage(obj)
          },
        })
      }
      return arr
    }
    return formatMenus(routes ?? allRoutes)
  }, [goToPage, allAuth, routes])

  const authedRoutes = filterRoutersByPermission<Omit<RouteConfig, 'path'>>(
    routes ?? allRoutes,
    allAuth,
  )
  const elements = useRoutes(authedRoutes as RouteObject[])

  return {
    authedRoutes,
    menuList,
    authRoutes: elements,
  }
}
